import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CustomScrollbars from './CustomScrollbars';
import { formatDate } from '../helpers/core';

class TasksList extends Component {
	render () {
		const { tasksList, onHistoryLinkClick } = this.props;

		return (
			<div className="panel task panel-warning">
				<div className="panel-heading sub-title">
					Задания
					<a href="#" className="pull-right task-history-link" onClick={onHistoryLinkClick}>История</a>
				</div>
				<div className="panel-body task-list">
					<CustomScrollbars autoHeight autoHeightMin={100} autoHeightMax={300}>
						{
							tasksList.map((task, key) => (
								<div className="row list-group-item" key={key}>
									<div className="col-xs-7 task-comment">{task.comment}</div>
									<div className="col-xs-5">
										<div className="col-xs-8">
											Сделать до: {formatDate(task.deadline)}
										</div>
									</div>
								</div>
							))
						}
					</CustomScrollbars>
				</div>
			</div>
		);
	}
}

TasksList.propTypes = {
	tasksList: PropTypes.array,
	onHistoryLinkClick: PropTypes.func
}

TasksList.defultProptypes = {
	onHistoryLinkClick: () => {}
}

export default TasksList;



// WEBPACK FOOTER //
// ./components/TasksList.js